module.exports = __webpack_public_path__ + "static/media/edit.0558eeb5.svg";